import * as ActionTypes from '../actions/actionTypes';
import * as ActionStatuses from '../actions/actionStatuses'
import objectPath from 'object-path';

export default function reduce(state = {}, action) {
    let newState, response, responseLoc;
    switch (action.type) {
        case ActionTypes.SET_NOTIFICATIONS_INITIALIZE_COMPLETE:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, true);
            return newState;

        case ActionTypes.STAGE_GET_NOTIFICATION_MESSAGES:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, { input: action.payload.request });
            return newState;

        case ActionTypes.HANDLE_GET_NOTIFICATION_MESSAGES:
            switch (action.status) {
                case ActionStatuses.begin:
                    return state;

                case ActionStatuses.complete:
                    responseLoc = action.payload.stateLocation;

                    response = Object.assign({
                        messageType: action.payload.messageType,
                        messageSource: action.payload.messageSource,
                        response: action.payload.response
                    });

                    if (action.error) {
                        response.error = true;
                        response.message = action.payload.response;
                        response.response = [];
                    }

                    newState = Object.assign({}, state);
                    objectPath.set(newState, responseLoc, response);

                    return newState;

                default:
                    return state;
            }

        case ActionTypes.STAGE_PROCESSED_NOTIFICATION_RESPONSE:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, 
                {
                    response: action.payload.response,
                    messageType: action.payload.messageType
                });
            return newState;

        case ActionTypes.UPDATE_POLLING_STATUS:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, action.payload.isPolling);
            return newState

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/reducers/index.js